import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup, FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatFormField, MatLabel, MatHint, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { DefaultLayoutDirective } from '../../../flex-layout/custom-layout';
import { DefaultFlexDirective } from '../../../flex-layout/flex';
import { SubscriptionPriceService } from '../../../services/subscription-price.service';
import { FieldConfig } from '../field.interface';

@Component({
  selector: 'calsoft-select',
  imports: [MatFormField, DefaultFlexDirective, MatLabel, MatSelect, FormsModule, ReactiveFormsModule, MatOption, MatHint, DefaultLayoutDirective, MatInput, MatError],
  templateUrl: './select.component.html',
  styleUrl: './select.component.scss'
})
export class SelectComponent implements OnInit {

  @Input() field: FieldConfig |any;
  @Input() group: UntypedFormGroup |any;
  @Input() index: any;
  @Input() indexInital: any;
  @Output() valueChange = new EventEmitter<any>();

  @Output() selectedValueChange = new EventEmitter<string>();

  optionsList: string[] = [];
  localFormControl: FormControl|any;
  reInit: boolean = false;

  selectedCustomFieldValue: string = '';
  customField5Values: string[] = [];
  selectedValue: string = '';
  selectedOptions: any;

  constructor(private subscriptionService: SubscriptionPriceService,
    private _formBuilder: FormBuilder,
  ) { }

 ngOnChanges(changes: SimpleChanges): void {
  if (changes['field'] && changes['field'].currentValue) {
    this.initializeOptions();
  }
}

  secondFormGroup: FormGroup |any;

  ngOnInit() {
    this.localFormControl = new FormControl('');
    this.initializeOptions();

    this.secondFormGroup = this._formBuilder.group({
      amount: ['', Validators.required],

    });

    this.secondFormGroup.get('amount')?.valueChanges.subscribe((amount:any) => {
      this.selectedCustomFieldValue = amount; // Update selectedCustomFieldValue
      this.subscriptionService.updateAmount(this.selectedCustomFieldValue); // Update subscription service
      console.log(this.selectedCustomFieldValue); // Log for debugging
    });

  }

  private initializeOptions(): void {
    this.localFormControl = new FormControl('');
    this.localFormControl.reset();
    let value: any = this.field.options;
    this.optionsList = value ? value.split(',') : [];

    this.customField5Values = this.field.customfield5 ? this.field.customfield5.split(',') : [];


    if (this.group.value[this.field.name] != null && this.group.value[this.field.name] != '') {
      this.localFormControl.setValue(this.group.value[this.field.name] || '');
    }

    this.reInit = true;
  }

  isRequired(fieldName: string): boolean {
    const control = this.group.get(fieldName);
    return control && control.hasError('required');
  }




  setValue(value: string): void {

    this.selectedValue = value;

    this.localFormControl.setValue(value);

    const control = this.group.get(this.field.name);
    if (control) {
      control.setValue(value);
      this.valueChange.emit(this.field.name);
    }

    if (this.field.customfield4 === '2') {
      const selectedIndex = this.optionsList.indexOf(value);
      if (selectedIndex > -1 && this.customField5Values[selectedIndex]) {
        this.selectedCustomFieldValue = this.customField5Values[selectedIndex];
      } else {
        this.selectedCustomFieldValue = '';
      }
    } else if (this.field.customfield4 === '4') {
      this.selectedOptions = value; 

      this.selectedCustomFieldValue = this.secondFormGroup.value.amount;

    }

    this.selectedValueChange.emit(this.selectedCustomFieldValue);

    this.subscriptionService.updateAmount(this.selectedCustomFieldValue)

  }
}
